import { Divider, Grid } from 'shared/components/Base/Base'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { Text } from 'shared/components/Text/Text'
import { darkGray, lightGray1, midGray } from 'shared/theme/colors'

import { formatReadableDate, formatReadableTime } from '../../../helpers/dateHelpers'
import { formatCurrency } from '../../../helpers/formatters'
import { DeductionConfig, Repayment, VendorProgramPolicyType } from '../../../models/repayments'
import { PolicyActivityItem } from './PolicyActivityItem'

interface PolicyPreviousDetailsProps {
  policy: Repayment
  config: DeductionConfig
}

const parseValue = (value: string | undefined | null): number => {
  if (!value) return 0
  if (isNaN(Number(value))) return 0
  return Number(value)
}

export function PolicyPreviousDetails({ policy, config }: PolicyPreviousDetailsProps) {
  const renderDateAndWeeklyDeduction = () => (
    <>
      <FlexBox justifyContent="space-between">
        <Text variant="header3" fontColor={lightGray1}>
          Start date
        </Text>
        <FlexBox isColumn alignItems="flex-end">
          <Text variant="header3" fontColor={darkGray}>
            {formatReadableDate(config.date_scheduled)}
          </Text>
          <Text variant="header3" fontColor={darkGray}>
            {formatReadableTime(config.date_scheduled)}
          </Text>
        </FlexBox>
      </FlexBox>
      <FlexBox justifyContent="space-between">
        <Text variant="header3" fontColor={lightGray1}>
          Weekly deduction
        </Text>
        <Text variant="header3" fontColor={darkGray}>
          {formatCurrency(
            policy.repayment_details.policy_type === VendorProgramPolicyType.SUBSCRIPTION
              ? config.subscription_periodic_amount
              : config.advance_periodic_amount
          )}
        </Text>
      </FlexBox>
    </>
  )

  const renderTotalDeductionAmount = () => (
    <>
      <FlexBox justifyContent="space-between">
        <Text variant="header3" fontColor={lightGray1}>
          Total deduction amount
        </Text>
        <Text variant="header3" fontColor={darkGray}>
          {formatCurrency(config.advance_total_billing_amount)}
        </Text>
      </FlexBox>
      <FlexBox justifyContent="space-between">
        <Text variant="header3" fontColor={lightGray1}>
          Correction
        </Text>
        <Text variant="header3" fontColor={darkGray}>
          {formatCurrency(
            (
              parseValue(config.advance_total_billing_amount) -
              parseValue(policy.repayment_details.total_amount_owed)
            ).toFixed(2)
          )}
        </Text>
      </FlexBox>
      <Divider />
      <FlexBox justifyContent="space-between">
        <Text variant="header3" fontColor={lightGray1}>
          Amount paid
        </Text>
        <Text variant="header3" fontColor={darkGray}>
          {formatCurrency(policy.repayment_details.amount_paid)}
        </Text>
      </FlexBox>
      <Divider />
      <FlexBox justifyContent="space-between">
        <Text variant="header3" fontColor={lightGray1}>
          Total remaining balance
        </Text>
        <Text variant="header3" fontColor={darkGray}>
          {formatCurrency(policy.repayment_details.remaining_payment)}
        </Text>
      </FlexBox>
    </>
  )

  return (
    <PolicyActivityItem config={config}>
      <Text variant="uppercaseLabel2" fontColor={midGray} align="left" mb={2}>
        PREVIOUS DEDUCTION DETAILS
      </Text>
      <Grid columns="300px 300px" gap="90px" smColumns="1fr" smGap="30px">
        <FlexBox isColumn gap="8px">
          {policy.repayment_details.policy_type === VendorProgramPolicyType.SUBSCRIPTION &&
            renderDateAndWeeklyDeduction()}
          {policy.repayment_details.policy_type === VendorProgramPolicyType.ADVANCE &&
            renderTotalDeductionAmount()}
        </FlexBox>
        <FlexBox isColumn gap="8px">
          {policy.repayment_details.policy_type === VendorProgramPolicyType.ADVANCE &&
            renderDateAndWeeklyDeduction()}
        </FlexBox>
      </Grid>
    </PolicyActivityItem>
  )
}
